<template>
  <div class="do-filters">
    <div class="do-filters__selected">
      <DDropdown :isShowDots="false"
                 :propOffset="[0, 8]"
                 :isCloseOnDropdownClick="false"
                 @onClose="onCloseDropdown">
        <button class="do-bttn do-bttn__filter" slot="title">
          <span class="icon-filter"></span>
          {{ title }}
          <div class="do-filters__divider"></div>
          <span class="do-filters__selected-filters" v-if="selectedTags.length === 0">
            {{ i18n['select_filters'] }}
          </span>
          <span class="do-badge" v-if="selectedTags.length > numberOfSelectedTagsToShow">
            {{ selectedTags.length }} {{ i18n['selected'] }}
          </span>
          <span class="do-badge" v-if="selectedTags.length <= numberOfSelectedTagsToShow" v-for="selectedTag in selectedTags" :key="selectedTag">
            {{ selectedTag }}
          </span>
        </button>
        <ul slot="list" class="do-filters__filter__dropdown" @click.stop>
          <div class="do-filters__filter__dropdown__header">
            <button @click="clearAll" class="do-filters__button-transparent">{{ i18n['clear_all'] }}</button>
            <input type="search" v-model="query" :placeholder="i18n['search_placeholder']" v-focus/>
          </div>
          <li class="do-list-item"
              v-for="item in filteredTags"
              @click="select(item)"
              :key="item">
            <div class="do-checkbox" :class="{'do-checkbox--selected': getIsItemSelected(item)}"></div>
            {{ item }}
          </li>
          <li v-if="filteredTags.length === 0" class="italic">{{ i18n['no_results'] }}</li>
        </ul>
      </DDropdown>
    </div>
  </div>
</template>

<script>
import DDropdown from '../common/DDropdown.vue'

const I18N = {
  da: {
    select_filters: 'Vælg filtre',
    selected: 'valgt',
    clear_all: 'Ryd alle',
    search_placeholder: 'Søg',
    no_results: 'Ingen resultater'
  },
  en: {
    select_filters: 'Select filters',
    selected: 'selected',
    clear_all: 'Clear all',
    search_placeholder: 'Search',
    no_results: 'No results'
  },
  nb: {
    select_filters: 'Velg filtre',
    selected: 'valgt',
    clear_all: 'Fjern alle',
    search_placeholder: 'Søk',
    no_results: 'Ingen resultater'
  }
}

export default {
  components: {DDropdown},
  props: {
    title: {
      type: String,
      default: 'Filtre'
    },
    tags: {
      type: Array,
      default: () => []
    },
    selectedTags: {
      type: Array,
      default: () => [] // ['Vikarer', 'Team 1', etc]
    },
    numberOfSelectedTagsToShow: {
      type: Number,
      default: 3
    }
  },
  directives: {
    focus: {
      inserted (el) {
        setTimeout(() => {
          el.focus()
        }, 0)
      }
    }
  },
  data () {
    return {
      query: ''
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale] || I18N['en']
    },
    sortedTags () {
      return this.tags.sort((a, b) => a.localeCompare(b, this.locale))
    },
    filteredTags () {
      return this.sortedTags.filter(tag =>
        tag.toLowerCase().includes(this.query.toLowerCase())
      )
    }
  },
  methods: {
    onCloseDropdown () {
      this.query = ''
    },
    clearAll () {
      this.$emit('clear')
    },
    select (tag) {
      this.$emit('select', tag)
    },
    getIsItemSelected (tag) {
      return this.selectedTags.includes(tag)
    }
  }
}
</script>

<style>
@import "../../assets/css/variables.css";

.do-list-item {
  display: flex;
  align-items: center;
  gap: 1rem
}

.do-checkbox {
  border: 1px solid #ccc;
  border-radius: .25rem;
  height: 1rem;
  position: relative;
  width: 1rem
}

.do-checkbox.do-checkbox--selected {
  background: var(--primary);
  border-color: var(--primary)
}

.do-checkbox.do-checkbox--selected:after,
.do-checkbox.do-checkbox--selected:before {
  background: #fff
}

.do-checkbox:after,
.do-checkbox:before {
  background: transparent;
  transform: rotate(35deg)
}

.do-checkbox:after {
  height: 8px;
  right: 3px;
  top: 1px;
  width: 1.5px;
}

.do-checkbox:after,
.do-checkbox:before {
  border-radius: 1rem;
  content: "";
  display: block;
  position: absolute
}

.do-checkbox.do-checkbox--selected:before {
  bottom: 2.5px;
  height: 1.5px;
  right: 5px;
  width: 4px;
}

.do-bttn.do-bttn__filter {
  display: inline-flex;
  align-items: center;
  font-size: 0.9rem;
  gap: 0.75rem;
  border: 1px dashed #e4e4e7;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, .05);
}

.do-bttn.do-bttn__filter:hover {
  background-color: #f4f4f5;
}

.do-bttn.do-bttn__filter > .icon-filter {
  font-size: 0.85rem;
}

.do-filters__divider {
  background: #e4e4e7;
  height: 65%;
  min-height: 2px;
  width: 1px;
}

.do-badge {
  background: #f4f4f5;
  border-radius: 4px;
  display: inline-block;
  font-size: 11px;
  font-weight: 400;
  padding: .15rem .35rem;
}

.do-filters__filter__dropdown {
  max-height: 50vh;
  overflow-y: auto;
  overscroll-behavior: contain;
}

button.do-filters__button-transparent {
  background: transparent;
  font-size: 0.85rem;
  border: 1px dashed #e4e4e7;
  color: #6c7a87;
  float: right;
  margin-bottom: 0.25rem;
  padding: 4px 8px;
  height: auto;
  box-shadow: none !important;
}

button.do-filters__button-transparent:focus {
  box-shadow: none !important;
}

.do-filters__filter__dropdown__header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e4e4e7;
  margin-bottom: 0.5rem;
}

.do-filters__selected-filters {
  color: #858585;
  font-weight: normal;
  font-style: italic;
}

.do-filters input[type="search"] {
  border-color: #acb6be;
}

.do-filters input[type="search"]:focus {
  border-color: #468ad7;
}
</style>



// WEBPACK FOOTER //
// DoFiltersFilter.vue?66ca9c8e